export default __webpack_public_path__ + "c945914.png";